module.exports = __webpack_public_path__ + "static/media/kp.7bf3cba9.svg";